import { Component, NgModule, ViewEncapsulation, ElementRef, Directive, HostBinding, } from '@angular/core';
import { CommonModule } from '@angular/common';
var /** @type {?} */ id = 0;
import { LyTheme } from './palette';
/**
 * Beta set force-color
 */
var LyForceColor = (function () {
    function LyForceColor() {
    }
    return LyForceColor;
}());
export { LyForceColor };
LyForceColor.decorators = [
    { type: Component, args: [{
                selector: '[ly-force-color]',
                template: "<ng-content></ng-content>",
                styles: [".force-color { fill: currentColor; } .force-color [fill]:not([fill=\"none\"]) { fill: currentColor; } "],
                encapsulation: ViewEncapsulation.None
            },] },
];
/**
 * @nocollapse
 */
LyForceColor.ctorParameters = function () { return []; };
function LyForceColor_tsickle_Closure_declarations() {
    /** @type {?} */
    LyForceColor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyForceColor.ctorParameters;
}
var LyRoot = (function () {
    /**
     * @param {?} elementRef
     * @param {?} theme
     */
    function LyRoot(elementRef, theme) {
        this.elementRef = elementRef;
        this.theme = theme;
        this.elementRef.nativeElement.setAttribute('style', "\n      display: inline-block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      font-family: Roboto, \"Helvetica Neue\", sans-serif;\n      overflow: auto;\n    ");
    }
    return LyRoot;
}());
export { LyRoot };
LyRoot.decorators = [
    { type: Directive, args: [{ selector: 'ly-core[root]' },] },
];
/**
 * @nocollapse
 */
LyRoot.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: LyTheme, },
]; };
function LyRoot_tsickle_Closure_declarations() {
    /** @type {?} */
    LyRoot.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyRoot.ctorParameters;
    /** @type {?} */
    LyRoot.prototype.elementRef;
    /** @type {?} */
    LyRoot.prototype.theme;
}
var LyInlineText = (function () {
    function LyInlineText() {
    }
    return LyInlineText;
}());
export { LyInlineText };
LyInlineText.decorators = [
    { type: Component, args: [{
                selector: 'inline-text',
                template: "<ng-content></ng-content>",
                styles: ["\n    :host {\n      vertical-align: middle;\n    }\n  "],
            },] },
];
/**
 * @nocollapse
 */
LyInlineText.ctorParameters = function () { return []; };
function LyInlineText_tsickle_Closure_declarations() {
    /** @type {?} */
    LyInlineText.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyInlineText.ctorParameters;
}
var LyCoreComponent = (function () {
    /**
     * @param {?} elementRef
     * @param {?} theme
     */
    function LyCoreComponent(elementRef, theme) {
        var _this = this;
        this.elementRef = elementRef;
        this.theme = theme;
        this.coreId = "" + id++;
        // this.palette.updateTheme();
        this.sub = this.theme.palette.subscribe(function (colors) {
            // console.log('COLORS', colors);
            if (_this._style) {
                _this.elementRef.nativeElement.removeChild(_this._style);
            }
            var styles = document.createElement('style');
            styles.setAttribute('core-id', _this.coreId);
            styles.innerHTML = "\n      [core-id=\"" + _this.coreId + "\"] .ly-primary-color {\n        color: " + colors.primary.color + "\n      }\n      [core-id=\"" + _this.coreId + "\"] .ly-primary-bg {\n        background: " + colors.primary.color + "\n      }\n      [core-id=\"" + _this.coreId + "\"] .ly-accent-color {\n        color: " + colors.accent.color + "\n      }\n      [core-id=\"" + _this.coreId + "\"] .ly-accent-bg {\n        background: " + colors.accent.color + "\n      }\n      [core-id=\"" + _this.coreId + "\"] .ly-other-color {\n        color: " + colors.other.color + "\n      }\n      [core-id=\"" + _this.coreId + "\"] .ly-other-bg {\n        background: " + colors.other.color + "\n      }\n      .vibrant-canvas {\n        display: none;\n      }\n      ";
            var __ = _this.elementRef.nativeElement.appendChild(styles);
            _this._style = __;
            _this.elementRef.nativeElement.style.display = 'block';
        });
    }
    /**
     * @return {?}
     */
    LyCoreComponent.prototype.ngOnDestroy = function () {
        // this.palette.destroyTheme();
    };
    return LyCoreComponent;
}());
export { LyCoreComponent };
LyCoreComponent.decorators = [
    { type: Directive, args: [{
                //.toString(),
                selector: 'ly-core',
            },] },
];
/**
 * @nocollapse
 */
LyCoreComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: LyTheme, },
]; };
LyCoreComponent.propDecorators = {
    'coreId': [{ type: HostBinding, args: ['attr.core-id',] },],
};
function LyCoreComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    LyCoreComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyCoreComponent.ctorParameters;
    /** @type {?} */
    LyCoreComponent.propDecorators;
    /** @type {?} */
    LyCoreComponent.prototype._style;
    /** @type {?} */
    LyCoreComponent.prototype.sub;
    /** @type {?} */
    LyCoreComponent.prototype.coreId;
    /** @type {?} */
    LyCoreComponent.prototype.elementRef;
    /** @type {?} */
    LyCoreComponent.prototype.theme;
}
var LyCoreModule = (function () {
    function LyCoreModule() {
    }
    /**
     * @return {?}
     */
    LyCoreModule.forRoot = function () {
        return {
            ngModule: LyCoreModule,
        };
    };
    return LyCoreModule;
}());
export { LyCoreModule };
LyCoreModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [LyCoreComponent, LyRoot, LyInlineText, LyForceColor],
                declarations: [LyCoreComponent, LyRoot, LyInlineText, LyForceColor],
            },] },
];
/**
 * @nocollapse
 */
LyCoreModule.ctorParameters = function () { return []; };
function LyCoreModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyCoreModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyCoreModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/core.js
// module id = 702
// module chunks = 31